var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"addVoucher"}},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.titles))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.loadstatus.voucherData.year)+"年"+_vm._s(_vm.loadstatus.voucherData.periods)+"期")])]),_vm._v(" "),_c('voucher-content',{ref:"voucherModel",on:{"on-world-change":_vm.getworldKey}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1563cdd0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/voucher/addVoucher.vue
// module id = null
// module chunks = 